import * as $ from "jquery";
import * as Backbone from "backbone";
import * as Marionette from "backbone.marionette";
import * as _ from "underscore";
import { on, Options } from "../../utils/decorators";
import getGalleryConfig from "../../config/gallery-config";
import GalleryView from "../../views/gallery-view";
import 'slick-carousel';

@Options({
    template: require("../templates/events-view.njk"),
    ui: {
        eventGallery: "[data-js-view=eventModalGallery]"
    }
})
export default class EventsModalView extends Marionette.View<Backbone.Model>{

    onRender() {
        let config = getGalleryConfig("event-modal");
        // let eventGallery = new GalleryView({
        //     el: "[data-js-view=eventModalGallery]",
        //     config: config
        // });
        // eventGallery.render();
        let $gallery = this.ui.eventGallery;
        ($gallery as any).slick(config)
    }
}



// WEBPACK FOOTER //
// ./@modules/modals/views/events-view.ts